import { createContext } from 'react';
import type { MenuItem, LinkColumn } from '_components/MegaMenu/types';

export interface MegaMenuMobileContextValue {
  activeItem: MenuItem | null;
  activeColumn: LinkColumn | null;
  handleItemClick: (item: MenuItem) => void;
  handleColumnClick: (column: LinkColumn) => void;
  handleBack: () => void;
  handleClose: () => void;
}

export const MegaMenuMobileContext =
  createContext<MegaMenuMobileContextValue | null>(null);
